import { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function useScrollAnimations() {
  useEffect(() => {
    // Hero section animations - faster, smoother
    gsap.fromTo(".hero-title",
      {
        y: 50,
        opacity: 0,
        scale: 0.95
      },
      {
        scrollTrigger: {
          trigger: ".hero-title",
          start: "top center+=200",
          toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: "power2.out"
      }
    )

    // About section cards - using toggleActions for better performance
    gsap.fromTo(".about-card", 
      {
        x: -50,
        opacity: 0,
        rotationY: 15
      },
      {
        scrollTrigger: {
          trigger: "#about",
          start: "top center+=150",
          toggleActions: "play none none reverse"
        },
        x: 0,
        opacity: 1,
        rotationY: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: "power2.out"
      }
    )

    // Stats animation
    gsap.fromTo(".stat-item",
      {
        scale: 0,
        rotation: 180
      },
      {
        scrollTrigger: {
          trigger: ".stat-item",
          start: "top center+=100",
          toggleActions: "play none none reverse"
        },
        scale: 1,
        rotation: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: "back.out(1.7)"
      }
    )

    // Features section
    gsap.fromTo(".feature-card",
      {
        y: 100,
        opacity: 0,
        scale: 0.8
      },
      {
        scrollTrigger: {
          trigger: "#features",
          start: "top center+=100",
          end: "bottom center",
          scrub: 1
        },
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 1,
        stagger: 0.2
      }
    )

    // Stats animation
    gsap.fromTo(".stat-item",
      {
        scale: 0,
        rotation: 180
      },
      {
        scrollTrigger: {
          trigger: ".stat-item",
          start: "top center+=100",
          toggleActions: "play none none reverse"
        },
        scale: 1,
        rotation: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: "back.out(1.7)"
      }
    )

    // Features section - using toggleActions for smoother performance
    gsap.fromTo(".feature-card",
      {
        y: 60,
        opacity: 0,
        scale: 0.9
      },
      {
        scrollTrigger: {
          trigger: "#features",
          start: "top center+=150",
          toggleActions: "play none none reverse",
          markers: false
        },
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.8,
        stagger: 0.15,
        ease: "power2.out"
      }
    )

    // Simplified glass effect for better performance
    gsap.set(".glass-effect", {
      backdropFilter: "blur(8px)",
      backgroundColor: "rgba(148, 163, 184, 0.08)"
    })

    // Navigation blur effect - simplified
    gsap.to("nav", {
      scrollTrigger: {
        trigger: "body",
        start: "top top-=50",
        toggleActions: "play none none reverse"
      },
      backdropFilter: "blur(12px)",
      backgroundColor: "rgba(15, 15, 35, 0.2)",
      duration: 0.3,
      ease: "power2.out"
    })

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill())
    }
  }, [])
}
